import { FieldControllerTypes, IFormController } from '../../../components/form_v2/types';
import { House, Person, LocationOn } from '@mui/icons-material';

export const insertErgoFields = (type_options: any[], locations: any[], 
  contributors: any[], formatOptions: any[]
// eslint-disable-next-line max-params
) => {
  const radioOptions = [
    { key: 'ΝΑΙ', value: 'ΝΑΙ' },
    { key: 'ΟΧΙ', value: 'ΟΧΙ' },
  ];

  const _radioOptions = [
    { key: 'Έγχρωμο', value: 'Έγχρωμο' },
    { key: 'Ασπρόμαυρο', value: 'Ασπρόμαυρο' },
  ];
      
  const insertStep1Form: IFormController[] = [
    {
      control: FieldControllerTypes.input,
      label: 'Μοναδικός Κωδικός Έργου',
      name: 'projectUniqueCode',
      required: true,
      disabled: true
    },
    {
      control: FieldControllerTypes.input,
      label: 'Aναγνωριστικό Έργου',
      name: 'projectIdentifier',
      required: true,
      disabled: true
    },
    {
      control: FieldControllerTypes.input,
      label: 'Τίτλος Έργου',
      name: 'projectTitle',
      required: true,
      disabled: true
    },
    {
      control: FieldControllerTypes.select,
      label: 'Τύπος Έργου',
      name: 'projectRelationWithTypeOfProject',
      options: type_options,
      customLabel: false,
      required: true
    },
    {
      control: FieldControllerTypes.input,
      label: 'Τίτλος Έργου στα Αγγλικά',
      name: 'projectEnTitle'
    },
    {
      control: FieldControllerTypes.input,
      label: 'Εναλλακτικός Τίτλος Έργου',
      name: 'projectAlternativeTitle'
    },
    {
      control: FieldControllerTypes.input,
      label: 'Ανήκει σε',
      name: 'projectBelongsTo'
    },
    {
      control: FieldControllerTypes.textarea,
      label: 'Περιγραφή Έργου',
      name: 'projectDescription',
    },
    {
      control: FieldControllerTypes.textarea,
      label: 'Περιγραφή Έργου στα Αγγλικά',
      name: 'projectEnDescription'
    },
    {
      control: FieldControllerTypes.input,
      label: 'Χρονολογία',
      name: 'projectYear'
    },
    {
      control: FieldControllerTypes.autoselect,
      label: 'Μορφότυπο',
      options: formatOptions,
      name: 'projectFormat',
      customLabel: true,
    },
    {
      control: FieldControllerTypes.input,
      label: 'Διάρκεια',
      name: 'projectDuration'
    },
    {
      control: FieldControllerTypes.radio,
      label: 'Χρώμα',
      name: 'projectColor',
      options: _radioOptions
    },
    {
      control: FieldControllerTypes.radio,
      label: 'Ήχος',
      name: 'projectSound',
      options: radioOptions
    },
    {
      control: FieldControllerTypes.input,
      label: 'Γλώσσα',
      name: 'projectLanguage'
    },
    {
      control: FieldControllerTypes.input,
      label: 'Χώρα',
      name: 'projectCountry'
    },
    {
      control: FieldControllerTypes.input,
      label: 'Μέγεθος',
      name: 'projectSize'
    },
    {
      control: FieldControllerTypes.input,
      label: 'Ύψος',
      name: 'projectHeight'
    },
    {
      control: FieldControllerTypes.input,
      label: 'Πλάτος',
      name: 'projectWidth',
    },
    {
      control: FieldControllerTypes.input,
      label: 'Frame Rate',
      name: 'projectFrameRate'
    },
    {
      control: FieldControllerTypes.input,
      label: 'Aspect Ratio',
      name: 'projectAspectRatio'
    },
    {
      control: FieldControllerTypes.textarea,
      label: 'Copyright',
      name: 'projectCopyright'
    }, 
    {
      control: FieldControllerTypes.input,
      label: 'Άδεια Χρήσης',
      name: 'projectCreativeCommons',
    },
    {
      control: FieldControllerTypes.radio,
      label: 'Εκπαιδευτικό',
      name: 'projectEducational',
      options: radioOptions
    },
    {
      control: FieldControllerTypes.input,
      label: 'Εκπαιδευτικό Ίδρυμα',
      name: 'projectEduInstitution'
    },
    {
      control: FieldControllerTypes.input,
      label: 'Εκπαιδευτική Βαθμίδα',
      name: 'projectEduLevel'
    },
    {
      control: FieldControllerTypes.input,
      label: 'Εκπαιδευτής',
      name: 'projectTrainer'
    },
    {
      control: FieldControllerTypes.input,
      label: 'Εργαστήριο',
      name: 'projectLab'
    }, 
    {
      control: FieldControllerTypes.textarea,
      label: 'Ομάδα Δημιουργίας',
      name: 'projectCreationTeam',
    },
    {
      control: FieldControllerTypes.input,
      label: 'Αριθμός Παιχτών',
      name: 'projectNumberPlayers'
    },
    {
      control: FieldControllerTypes.input,
      label: 'Κοινός Στόχος',
      name: 'projectsMutualGoal'
    },
    {
      control: FieldControllerTypes.input,
      label: 'Διοργάνωση',
      name: 'projectOrganisation'
    },
    {
      control: FieldControllerTypes.input,
      label: 'Βραβεία',
      name: 'projectAward'
    },
    {
      control: FieldControllerTypes.textarea,
      label: 'Παρατηρήσεις - Σχόλια Ο/Α Έργου',
      name: 'projectComments'
    },
    {
      control: FieldControllerTypes.textarea,
      label: 'Παρατηρήσεις - Σχόλια Ο/Α Έργου στα Αγγλικά',
      name: 'projectEnComments'
    }
  ];
  const insertStep2Form: IFormController[] = [
    {
      control: FieldControllerTypes.autocomplete,
      label: 'Εμπλεκόμενοι του Έργου - Συντελεστές',
      name: 'projectConnectorWithContributor',
      customLabel: true,
      info: true,
      tooltip: 'Για να προσθέσετε νέο εμπλεκόμενο χρησιμοποιήστε το κουμπί στην αρχή της φόρμας',
      options: contributors
    }
  ];
  const insertStep3Form: IFormController[] = [
    {
      control: FieldControllerTypes.autocomplete,
      label: 'Σχετικές Τοποθεσίες',
      name: 'projectRelationWithLocation',
      customLabel: true,
      options: locations
    },
    {
      control: FieldControllerTypes.input,
      label: 'Άλλες Σχετικές Τοποθεσίες',
      name: 'projectOtherLocations',
    }
  ];

  const insertStep1 = {
    label: 'Βασικές Πληροφορίες Ο/Α Έργου',
    content: insertStep1Form,
    icon: <House/>
  };
  const insertStep2 = {
    label: 'Εμπλεκόμενοι του Έργου - Συντελεστές',
    content: insertStep2Form,
    icon: <Person/>
  };
  const insertStep3 = {
    label: 'Σχετικές Τοποθεσίες',
    content: insertStep3Form,
    icon: <LocationOn/>
  };


  return [
    {...insertStep1},
    {...insertStep2},
    {...insertStep3}
  ];
};